import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

/** Shown when submitting an order would take the project over its budget. Someone who can approve may go ahead with a written reason;
 *  the reason is kept in the audit trail. Anyone else is told by the server that they may not override. */
export function BudgetOverrideDialog({ detail, what = "order", onCancel, onSubmit }) {
  const [reason, setReason] = useState("");
  const ok = reason.trim().length >= 10;
  return (
    <Dialog open onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-lg" data-testid="budget-override-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><AlertTriangle className="h-5 w-5 text-amber-600" /> This {what} is over budget</DialogTitle>
          <DialogDescription>{detail?.message}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-3 gap-2 rounded-lg border bg-muted/30 p-3 text-center text-sm" data-testid="budget-override-figures">
          <div><div className="text-xs text-muted-foreground">Budget</div><div className="font-semibold tabular-nums">{inr(detail?.budget)}</div></div>
          <div><div className="text-xs text-muted-foreground">With this {what}</div><div className="font-semibold tabular-nums">{inr(detail?.after)}</div></div>
          <div><div className="text-xs text-muted-foreground">Over by</div><div className="font-semibold tabular-nums text-rose-600">{inr(detail?.over)}</div></div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="budget-reason">Reason for going ahead (kept in the audit trail)</Label>
          <Textarea id="budget-reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={3} data-testid="budget-override-reason" placeholder="For example: client asked for extra work; variation VO-0004 is being raised" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="budget-override-cancel">Cancel</Button>
          <Button disabled={!ok} onClick={() => onSubmit(reason.trim())} data-testid="budget-override-submit">Submit with reason</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
